<div class="upsell-items padded-right-20-md padded-right-20-sm padded-right-sm-down padded-left-20">
  <h3 class="font-secondary upsell-items-title" [attr.aria-label]="'component.sister_upsells.frequently' | translate">
    {{'component.sister_upsells.frequently' | translate}}: </h3>

  <div class="upsell-items-container">
    <div *ngFor="let upsellItem of upsellItems" class='upsell-item-container'>
      <fts-sister-upsell [upsell]="upsellItem" (itemAddedToOrder)="onUpsellItemAdded($event)" class='full-width'></fts-sister-upsell>
    </div>
  </div>
</div>
